import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MeilleuresBiens } from 'app/models/meilleursBiens';
import { Observable, Subject, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MeilleursBiensService {

  base_path = 'https://app.titv-store-api.com/';

  constructor(private http: HttpClient) { }

  private refreshData = new Subject<void>();
  
  get refreshNedeed() {
    return this.refreshData;
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private getToken(): string {
    try {
      const authUser = sessionStorage.getItem('auth-user');
      if (authUser) {
        const userObj = JSON.parse(authUser);
        return userObj.token || '';
      }
      return '';
    } catch {
      return '';
    }
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private getHeaders(): HttpHeaders {
    const token = this.getToken();
    
    if (token) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      });
    }
    
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Une erreur est survenue';
    
    if (error.status === 403) {
      errorMessage = `Accès interdit. Token: ${this.getToken() ? 'présent' : 'absent'}`;
    } else if (error.status === 401) {
      errorMessage = 'Non autorisé. Veuillez vous reconnecter.';
    } else {
      errorMessage = `Erreur ${error.status}: ${error.message}`;
    }
    
    console.error('Erreur MeilleursBiensService:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  // ✅ CORRECTION : Ajouter headers
  getAgencieMeilleursBiens() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/all/meilleursbiens',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Create a new item
  createMeilleuresBiens(item: any): Observable<MeilleuresBiens> {
    const headers = this.getHeaders();
    
    return this.http.post<MeilleuresBiens>(
      this.base_path + 'agencies/signupagency', 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // Get single MeilleuresBiens data by ID
  getMeilleuresBiens(id: any): Observable<MeilleuresBiens> {
    const headers = this.getHeaders();
    
    return this.http.get<MeilleuresBiens>(
      this.base_path + 'biens/all/' + id,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Update item by id
  updateMeilleuresBiens(id: any, item: any): Observable<MeilleuresBiens> {
    const headers = this.getHeaders();
    
    return this.http.put<MeilleuresBiens>(
      this.base_path + 'agencies/edit/' + id, 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // Delete item by id
  deleteMeilleursBiens(id: any): Observable<any> {
    const headers = this.getHeaders();
    
    return this.http.delete<any>(
      this.base_path + 'agencies/delete/' + id, 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // Get biens data
  getListMeilleuresBiens(): Observable<MeilleuresBiens[]> {
    const headers = this.getHeaders();
    
    return this.http.get<MeilleuresBiens[]>(
      this.base_path + 'biens/all/mb',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  deleteMBiens(id: any): Observable<any> {
    const headers = this.getHeaders();
    
    return this.http.delete<any>(
      this.base_path + 'biens/delete/' + id, 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // ✅ CORRECTION : Toutes les méthodes suivantes doivent aussi envoyer le token
  getMeilleursBiensParVille(ville: string) {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/meilleursbiens/' + ville,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMeilleursBiensSousse() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/meilleursbiens/sousse',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMeilleursBiensTunis() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/meilleursbiens/tunis',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMeilleursBiensMonastir() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/meilleursbiens/monastir',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMeilleursBiensMahdia() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/meilleursbiens/mahdia',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMeilleursBiensBizerte() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/meilleursbiens/bizerte',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMeilleursBiensSfax() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/meilleursbiens/sfax',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMeilleursBiensNabeul() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/meilleursbiens/nabeul',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
}